// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-characteristics/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springCharacteristicsEN: PageEntry = {
  id: "post.federcharakteristik",
  locale: "en",
  slug: "spring-characteristics",
  seo: {
    title: "Glossary: Spring characteristics explained simply | Dietz GmbH",
    description: "The spring characteristics describe the specific mechanical properties of a spring that determine its reaction to external loads. This includes parameters such as spring constant, ",
  },
  type: "post",
  h1: "Glossary: Spring characteristics explained simply",
  intro: "The spring characteristics describe the specific mechanical properties of a spring that determine its reaction to external loads. This includes parameters such as spring constant, spring stiffness, spring load limit and damping. The characteristics of a spring influence its possible uses in various applications. For example, a spring with a stiff characteristic is suitable for applications that require high forces, while a softer characteristic is suitable for applications with lower loads. Precise knowledge of the spring characteristics is crucial for the selection and design of springs in technical systems.",
  blocks: [

  ],
};
